/* tslint:disable */

declare var Object: any;
export interface InspectionFormModuleInterface {
  "name": string;
  "required": boolean;
  "id"?: any;
}

export class InspectionFormModule implements InspectionFormModuleInterface {
  "name": string;
  "required": boolean;
  "id": any;
  constructor(data?: InspectionFormModuleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InspectionFormModule`.
   */
  public static getModelName() {
    return "InspectionFormModule";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InspectionFormModule for dynamic purposes.
  **/
  public static factory(data: InspectionFormModuleInterface): InspectionFormModule{
    return new InspectionFormModule(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InspectionFormModule',
      plural: 'InspectionFormModules',
      path: 'InspectionFormModules',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "required": {
          name: 'required',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
